import { IsInt, IsNumber, Max, Min } from 'class-validator';

export class ValueDto {
  @IsNumber()
  timestamp!: number;

  @IsInt()
  @Min(0)
  @Max(2)
  entryType!: 0 | 1 | 2;

  @IsInt()
  value!: number;
}
